msgid ""
msgstr ""
"POT-Creation-Date: 2025-06-01 16:28-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: fr\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: content.size
#: projects/har/tabs/Body/Header.tsx:36
msgid "{0, plural, one {# byte} other {# bytes}}"
msgstr "{0, plural, one {# octet} other {# octets}}"

#. placeholder {0}: excludeValue.size
#: projects/har/toolbar/HostTypeModal.tsx:107
msgid "{0, plural, one {# host excluded} other {# hosts excluded}}"
msgstr "{0, plural, one {# hôte exclu} other {# hôtes exclus}}"

#. placeholder {0}: includeValue.size
#: projects/har/toolbar/HostTypeModal.tsx:96
msgid "{0, plural, one {# host included} other {# hosts included}}"
msgstr "{0, plural, one {# hôte inclus} other {# hôtes inclus}}"

#. placeholder {0}: entries.length
#: projects/har/App.tsx:347
msgid "{0, plural, one {# request.} other {# requests.}}"
msgstr "{0, plural, one {# requête.} other {# requêtes.}}"

#. placeholder {0}: includeValue.size
#. placeholder {0}: excludeValue.size
#: projects/har/toolbar/MimeTypeModal.tsx:157
#: projects/har/toolbar/MimeTypeModal.tsx:168
msgid "{0, plural, one {# type included} other {# types included}}"
msgstr "{0, plural, one {# type inclus} other {# types inclus}}"

#: projects/har/components/AboutModal.tsx:69
msgid "<0>{selected}</0> is offered under the following terms:"
msgstr "<0>{selected}</0> est offert sous les termes suivants :"

#: projects/har/components/AboutModal.tsx:74
msgid "<0>{selected}</0> is used under the following license:"
msgstr "<0>{selected}</0> est utilisé sous les termes de la licence suivante :"

#: projects/har/components/AboutModal.tsx:105
msgid "About"
msgstr "À propos"

#: projects/har/toolbar/StatusCodeFilter.tsx:45
msgid "All"
msgstr "Tous"

#: projects/har/components/AboutModal.tsx:34
msgid "All Rights Reserved."
msgstr "Tous droits réservés."

#: projects/har/tabs/QuickType/index.tsx:117
msgid "Alphabetize"
msgstr "Alphabétiser"

#: projects/har/tabs/Timeline.tsx:30
msgid "Blocked"
msgstr "Bloqué"

#: projects/har/components/FilterModal.tsx:150
msgid "Clear"
msgstr "Effacer"

#: projects/har/tabs/Timeline.tsx:32
msgid "Connect"
msgstr "Connexion"

#: projects/har/App.tsx:176
#: projects/har/tabs/Body/index.tsx:236
msgid "Content"
msgstr "Contenu"

#: projects/har/App.tsx:177
msgid "Cookies"
msgstr "Cookies"

#: projects/har/tabs/Request.tsx:88
#: projects/har/tabs/Request.tsx:102
msgid "Copied to clipboard"
msgstr "Copié dans le presse-papiers"

#: projects/har/tabs/Request.tsx:78
msgid "Copy"
msgstr "Copier"

#: projects/har/tabs/Request.tsx:108
msgid "Copy as axios"
msgstr "Copier au format axios"

#: projects/har/tabs/Request.tsx:94
msgid "Copy as fetch"
msgstr "Copier au format fetch"

#: src/toolbar/DarkMode.tsx:39
msgid "Dark"
msgstr "Mode sombre"

#: projects/har/toolbar/MimeTypeModal.tsx:117
msgid "Data Only"
msgstr "Données uniquement"

#: projects/har/tabs/Timeline.tsx:31
msgid "DNS"
msgstr "DNS"

#: projects/har/components/FilterModal.tsx:153
msgid "Done"
msgstr "Terminé"

#: projects/har/tabs/Body/Header.tsx:60
msgid "Download"
msgstr "Télécharger"

#: projects/har/App.tsx:321
msgid "Drag a HAR file here."
msgstr "Déposez un fichier HAR ici."

#: projects/har/components/DropHarTips.tsx:21
msgid "Drop your HAR file here…"
msgstr "Déposez votre fichier HAR ici…"

#: projects/har/tabs/Body/index.tsx:177
msgid "Editor"
msgstr "Éditeur"

#: projects/har/tabs/Cookies.tsx:47
#: src/components/KVTable.tsx:43
msgid "Empty"
msgstr "Vide"

#: projects/har/tabs/Body/JSONView.tsx:61
msgid "Evaluate"
msgstr "Évaluer"

#: projects/har/toolbar/HostTypeModal.tsx:57
msgid "Exclude background and telemetry"
msgstr "Exclure le fond et la télémétrie"

#: projects/har/toolbar/HostTypeModal.tsx:45
msgid "Excluded hosts"
msgstr "Hôtes exclus"

#: projects/har/toolbar/MimeTypeModal.tsx:105
msgid "Excluded mime types"
msgstr "Types MIME exclus"

#: projects/har/components/ViewStateDropdown.tsx:133
msgid "Export to clipboard"
msgstr "Exporter dans le presse-papiers"

#: projects/har/components/ViewStateDropdown.tsx:111
msgid "Export to file"
msgstr "Exporter dans un fichier"

#: projects/har/toolbar/HostTypeModal.tsx:118
msgid "Filter by host…"
msgstr "Filtrer par hôte…"

#: projects/har/toolbar/MimeTypeModal.tsx:179
msgid "Filter by mime types…"
msgstr "Filtrer par types MIME…"

#: projects/har/components/ViewStateDropdown.tsx:37
msgid "Filter settings"
msgstr "Réglages de filtrage"

#: projects/har/tabs/PostData.tsx:211
#: projects/har/tabs/PostData.tsx:250
msgid "Form data"
msgstr "Données du formulaire"

#: projects/har/App.tsx:221
msgid "HAR files"
msgstr "Fichiers HAR"

#: projects/har/tabs/Response.tsx:32
#: projects/har/tabs/Response.tsx:34
#: projects/har/tabs/Request.tsx:67
#: projects/har/tabs/Request.tsx:69
msgid "Headers"
msgstr "En-têtes"

#: projects/har/App.tsx:211
msgid "Hide sidebar"
msgstr "Cacher la barre latérale"

#: projects/har/toolbar/HostTypeModal.tsx:63
msgid "Host"
msgstr "Hôte"

#: projects/har/components/ViewStateDropdown.tsx:86
msgid "Import from clipboard"
msgstr "Importer depuis le presse-papiers"

#: projects/har/components/ViewStateDropdown.tsx:61
msgid "Import from file"
msgstr "Importer depuis un fichier"

#: projects/har/toolbar/HostTypeModal.tsx:47
msgid "Included hosts"
msgstr "Hôtes inclus"

#: projects/har/toolbar/MimeTypeModal.tsx:107
msgid "Included mime types"
msgstr "Types MIME inclus"

#: projects/har/components/Initiator.tsx:84
#: projects/har/components/Initiator.tsx:91
msgid "Initiator"
msgstr "Initiateur"

#: projects/har/tabs/Body/index.tsx:176
msgid "Inspect"
msgstr "Inspecter"

#: projects/har/tabs/PostData.tsx:209
#: projects/har/tabs/PostData.tsx:252
msgid "JSON"
msgstr "JSON"

#: projects/har/tabs/QuickType/index.tsx:85
msgid "Language"
msgstr "Langue"

#: src/toolbar/DarkMode.tsx:36
msgid "Light"
msgstr "Mode clair"

#: projects/har/tabs/PostData.tsx:181
#: projects/har/components/Loading.tsx:7
msgid "Loading"
msgstr "Chargement"

#: projects/har/toolbar/MethodFilter.tsx:33
#: projects/har/toolbar/MethodFilter.tsx:36
msgid "Method"
msgstr "Méthode"

#: projects/har/tabs/Body/Header.tsx:31
msgid "MIME"
msgstr "MIME"

#: projects/har/toolbar/MimeTypeModal.tsx:123
msgid "Mime Type"
msgstr "Type MIME"

#: projects/har/tabs/PostData.tsx:248
msgid "Multipart form data"
msgstr "Données de formulaire multipart"

#: projects/har/tabs/QuickType/index.tsx:105
msgid "Name"
msgstr "Nom"

#: projects/har/tabs/Body/index.tsx:240
msgid "No content to display."
msgstr "Aucun contenu à afficher."

#: projects/har/tabs/Cookies.tsx:40
msgid "No cookie to display."
msgstr "Aucun cookie à afficher."

#: projects/har/App.tsx:308
msgid "No entries available."
msgstr "Aucune entrée disponible."

#: projects/har/tabs/Response.tsx:33
#: projects/har/tabs/Request.tsx:68
msgid "No headers"
msgstr "Aucun en-tête"

#: projects/har/tabs/Response.tsx:26
msgid "No status text"
msgstr "Aucun texte de statut"

#: projects/har/tabs/Body/index.tsx:96
msgid "Not applicable."
msgstr "Sans objet."

#: projects/har/App.tsx:228
msgid "Open file"
msgstr "Ouvrir"

#: projects/har/tabs/PostData.tsx:217
#: projects/har/tabs/PostData.tsx:233
#: projects/har/tabs/PostData.tsx:235
msgid "POST data"
msgstr "Données POST"

#: projects/har/tabs/Body/index.tsx:181
msgid "Preview"
msgstr "Aperçu"

#: projects/har/tabs/Request.tsx:55
#: projects/har/tabs/Request.tsx:57
msgid "Query string"
msgstr "Chaîne de requête"

#: projects/har/tabs/Timeline.tsx:35
msgid "Receive"
msgstr "Reçu"

#: projects/har/App.tsx:174
msgid "Request"
msgstr "Requête"

#: projects/har/components/EntryList.tsx:80
msgid "Request list"
msgstr "Liste des requêtes"

#: projects/har/App.tsx:175
#: projects/har/tabs/Body/index.tsx:102
msgid "Response"
msgstr "Réponse"

#: projects/har/components/EntryList.tsx:66
msgid "Search"
msgstr "Rechercher"

#: projects/har/components/FilterModal.tsx:118
msgid "Search…"
msgstr "Rechercher…"

#: projects/har/components/AboutModal.tsx:86
msgid "Select a license to view its license."
msgstr "Sélectionner une licence pour afficher sa licence."

#: projects/har/tabs/Timeline.tsx:33
msgid "Send"
msgstr "Envoyer"

#: projects/har/tabs/QuickType/index.tsx:81
msgid "Settings"
msgstr "Paramètres"

#: projects/har/App.tsx:211
msgid "Show sidebar"
msgstr "Afficher la barre latérale"

#: projects/har/tabs/Body/Header.tsx:35
msgid "Size"
msgstr "Taille"

#: projects/har/components/ErrorMessage.tsx:6
msgid "Something went wrong: "
msgstr "Quelque chose s’est mal passé : "

#: projects/har/tabs/Timeline.tsx:36
msgid "SSL"
msgstr "SSL"

#: projects/har/tabs/Timeline.tsx:27
msgid "Start"
msgstr "Début"

#: projects/har/toolbar/StatusCodeFilter.tsx:36
#: projects/har/toolbar/StatusCodeFilter.tsx:37
msgid "Status code"
msgstr "Code de statut"

#: projects/har/tabs/Request.tsx:89
#: projects/har/tabs/Request.tsx:103
msgid "Successfully copied to clipboard"
msgstr "Copié avec succès dans le presse-papiers"

#: src/toolbar/DarkMode.tsx:42
msgid "System"
msgstr "Système"

#: projects/har/tabs/PostData.tsx:236
msgid "Text"
msgstr "Texte"

#: projects/har/tabs/Body/FontView.tsx:21
msgid "The quick brown fox jumps over the lazy dog."
msgstr "Portez ce vieux whisky au juge blond qui fume."

#: src/toolbar/DarkMode.tsx:30
msgid "Theme switch"
msgstr "Changer de thème"

#: projects/har/App.tsx:143
msgid "This file is not a valid HAR file."
msgstr "Ce fichier n’est pas un fichier HAR valide."

#: projects/har/App.tsx:178
msgid "Timeline"
msgstr "Chronologie"

#: projects/har/tabs/Timeline.tsx:23
#: projects/har/tabs/Timeline.tsx:24
msgid "Timings"
msgstr "Temps"

#: projects/har/tabs/Cookies.tsx:34
msgid "Title"
msgstr "Titre"

#: projects/har/tabs/Timeline.tsx:37
msgid "Total"
msgstr "Total"

#: projects/har/tabs/Body/index.tsx:181
msgid "Type"
msgstr "Type"

#: projects/har/tabs/Cookies.tsx:37
msgid "Value"
msgstr "Valeur"

#: projects/har/tabs/Timeline.tsx:34
msgid "Wait"
msgstr "Attente"
